var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex mb-2" }, [
      _c(
        "button",
        {
          staticClass: "ml-auto btn btn-danger",
          attrs: { disabled: !_vm.isSelected },
          on: { click: _vm.showModal }
        },
        [
          _c("i", { staticClass: "fa fa-trash" }),
          _vm._v("\n      Delete\n    ")
        ]
      )
    ]),
    _c(
      "table",
      {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.fetchMore,
            expression: "fetchMore"
          }
        ],
        staticClass: "table table-hover table-responsive",
        attrs: {
          "infinite-scroll-disabled": "moreDisabled",
          "infinite-scroll-distance": "100"
        }
      },
      [
        _vm._m(0),
        _c(
          "tbody",
          _vm._l(_vm.modifiedFiles, function(file, index) {
            return _c("file-row", { key: file.id, attrs: { file: file } })
          })
        )
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "delete-file-modal",
          role: "dialog",
          tabindex: "-1",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _vm._m(2),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.deleteFiles }
                  },
                  [_vm._v("OK")]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [_c("th"), _c("th", [_vm._v("#")]), _c("th", [_vm._v("name")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("\n            Are you sure?\n          ")
      ]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [_vm._v("\n            It cannot be undone.\n          ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25d7d024", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d7d024","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/file-list.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-25d7d024","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/file-list.vue
// module chunks = 16